import React from "react";
import { useLocation } from "react-router-dom";

const FooterLogos = ({ showFundingText = true, containerClass = "items-center justify-between w-full mt-2 flex flex-col text-white" }) => {
  const location = useLocation();
  
  // Return null if the current path is not "/"
  if (location.pathname !== "/") {
    return null;
  }
  
  return (
    <div className={containerClass}>
      <div className="w-3/3 mt-24">
        {showFundingText && (
          <>
            <div className="text-xs pb-2">Proyecto financiado por el IANEM, Ministerio de Cultura y Deporte</div>
            <div className="text-xs pb-2">Financiado por la Unión Europea-Next Generation EU</div>
          </>
        )}
        <div className="flex items-center flex-row justify-between w-full text-white">
          <img
            width="180px"
            className="pr-2"
            src="https://assets-img.primaverasound.com/0x300/psweb/nvude2d1q1y7v7a8tv3v_1697642759168.png"
            alt="Logotipos"
          />
          <img
            width="130px"
            className="pr-4"
            src="https://assets-img.primaverasound.com/0x300/psweb/9gamesxx489wc1umrhpd_1697642656436.png"
            alt="Logotipos"
          />
          <img
            width="200px"
            className="pr-2"
            src="https://assets.primaverasound.com/psweb/5ghmau96d1qc6ev29kk7_1759080669028.png"
            alt="Logotipos"
          />
        </div>
      </div>
    </div>
  );
};

export default FooterLogos;
